const getters = {
    getIdMainGroup: state => state.id_main_group,
    getGroup: state => state.groups,
    getGroupUser: state => state.groupsUser,
    getVolume: state => state.volumes,
    getSubgroup: state => state.subgroup,
    getSubgroupUser: state => state.subgroupUser,
    getLanguage: state => state.language,
    getRole: state => state.roles,
    getModalImportUsers:state=>state.openModalImportUsers,
    getModalSupport:state=>state.openModalSupport,
    getModalActiveVolumen:state=>state.openModalActiveVolumen,
    getModalImportUserSubGroup:state=>state.ModalImportUserSubGroup,
    getModalImportUserGroup:state=>state.ModalImportUserGroup,
    getModalImportSubgroup:state=>state.ModalImportSubgroup
};
export default getters;